import register from './register.es';

export default {
	register
};